export const translate = {
	es: {
		auto: 'Autoevaluación',
		peer: 'Pares',
		team: 'Jefe',
		boss: 'Equipo',
	},
	pt: {
		auto: 'Autoavaliação',
		peer: 'Pares',
		team: 'Chefe',
		boss: 'Equipe',
	},
}
